var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.listItem
  }, [_c('div', {
    class: _vm.theme.label
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label))], {
    label: _vm.label
  })], 2), _vm._v(" "), _c('div', [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f6b1530","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/List/ListItem.vue
// module id = 591
// module chunks = 0